import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPaychexConfirmEmployerContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PaychexConfirmEmployerContainer" */
                '@perpay-web/fintech/components/composite/PaychexOnboarding/PaychexConfirmEmployerContainer'
            ),
    );
